
import { defineComponent, PropType } from 'vue';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import { AvailableViews } from './DemotionPopup.vue';
import omegaup_RadioSwitch from '../RadioSwitch.vue';
import T from '../../lang';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
library.add(faTrash);

interface ProblemTag {
  text: string;
  value: string;
}

export default defineComponent({
  name: 'QualityNominationReviewerPopup',
  components: {
    'omegaup-overlay-popup': omegaup_OverlayPopup,
    'omegaup-radio-switch': omegaup_RadioSwitch,
    'vue-typeahead-bootstrap': VueTypeaheadBootstrap,
    FontAwesomeIcon,
  },
  props: {
    allowUserAddTags: {
      type: Boolean,
      default: false,
    },
    levelTags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    problemLevel: {
      type: String,
      default: '',
    },
    possibleTags: {
      type: Array as PropType<string[]>,
      default: () => [
        'problemLevelAdvancedCompetitiveProgramming',
        'problemLevelAdvancedSpecializedTopics',
        'problemLevelBasicIntroductionToProgramming',
        'problemLevelBasicKarel',
        'problemLevelIntermediateAnalysisAndDesignOfAlgorithms',
        'problemLevelIntermediateDataStructuresAndAlgorithms',
        'problemLevelIntermediateMathsInProgramming',
      ],
    },
    publicTags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    selectedPublicTags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    selectedPrivateTags: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    problemAlias: {
      type: String,
      default: '',
    },
    problemTitle: {
      type: String,
      default: '',
    },
  },
  emits: ['dismiss', 'rate-problem-as-reviewer'],
  data() {
    return {
      AvailableViews,
      T,
      currentView: AvailableViews.Content as AvailableViews,
      qualitySeal: true,
      publicTagsList: (this.selectedPublicTags
        ? [...this.selectedPublicTags]
        : []) as string[],
    };
  },
  computed: {
    sortedProblemTags(): ProblemTag[] {
      return this.possibleTags
        .map(
          (x: string): ProblemTag => {
            return {
              value: x,
              text: T[x],
            };
          },
        )
        .sort((a: ProblemTag, b: ProblemTag): number => {
          return a.text.localeCompare(b.text, T.lang);
        });
    },
  },
  watch: {
    selectedPublicTags(newTags: string[]) {
      this.publicTagsList = [...(newTags ?? [])];
    },
  },
  methods: {
    addOtherTag(tag: string): void {
      if (!this.publicTagsList.includes(tag)) {
        this.publicTagsList.push(tag);
      }
    },

    publicTagsSerializer(tagname: string): string {
      if (Object.prototype.hasOwnProperty.call(T, tagname)) {
        return T[tagname];
      }
      return tagname;
    },

    getName(alias: string): string {
      return T[alias];
    },

    removeTag(name: string) {
      const pos = this.publicTagsList.indexOf(name);
      if (pos !== -1) {
        this.publicTagsList.splice(pos, 1);
      }
    },

    onHide(): void {
      this.$emit('dismiss');
    },

    onSubmit(): void {
      this.$emit('rate-problem-as-reviewer', {
        tags: this.publicTagsList,
        qualitySeal: this.qualitySeal,
      });
      this.currentView = AvailableViews.Thanks;
      setTimeout(() => this.onHide(), 2000);
    },
  },
});
